import React from 'react';
import type { CandidatesConst } from '@axiom/const';

import { Badge } from '../../element/Badge/Badge';
import { backgroundColorNames, colors } from '../../../theme/axiom-theme';

export type ProfileStatus =
  (typeof CandidatesConst.ProfileStatuses)[keyof typeof CandidatesConst.ProfileStatuses];
type BackgroundColor =
  (typeof backgroundColorNames)[keyof typeof backgroundColorNames];
type Colors = (typeof colors)[keyof typeof colors];

export type ColorInfo = {
  colorName: BackgroundColor;
  colorCode: Colors;
};

export const profileStatusColors: Record<ProfileStatus, ColorInfo> = {
  Active: {
    colorName: backgroundColorNames.blue,
    colorCode: colors.dataVizBlue,
  },
  Alum: {
    colorName: backgroundColorNames.yellow,
    colorCode: colors.dataVizYellow,
  },
  'Alum DNR': {
    colorName: backgroundColorNames.gray,
    colorCode: colors.dataVizGray,
  },
  Beach: {
    colorName: backgroundColorNames.red,
    colorCode: colors.dataVizRed,
  },
  Certifying: {
    colorName: backgroundColorNames.sky,
    colorCode: colors.dataVizSky,
  },
  Idle: {
    colorName: backgroundColorNames.avocado,
    colorCode: colors.dataVizAvocado,
  },
  'In Diligence': {
    colorName: backgroundColorNames.sky,
    colorCode: colors.dataVizSky,
  },
  'New Lead': {
    colorName: backgroundColorNames.avocado,
    colorCode: colors.dataVizAvocado,
  },
  'Pending Active': {
    colorName: backgroundColorNames.blue,
    colorCode: colors.dataVizBlue,
  },
  'Pending Alum': {
    colorName: backgroundColorNames.purple,
    colorCode: colors.dataVizPurple,
  },
  'Pending Alum DNR': {
    colorName: backgroundColorNames.gray,
    colorCode: colors.dataVizGray,
  },
  'Pending Beach': {
    colorName: backgroundColorNames.red,
    colorCode: colors.dataVizRed,
  },
  Rejected: {
    colorName: backgroundColorNames.gray,
    colorCode: colors.dataVizGray,
  },
  Reservoir: {
    colorName: backgroundColorNames.avocado,
    colorCode: colors.dataVizAvocado,
  },
  Waitlist: {
    colorName: backgroundColorNames.sky,
    colorCode: colors.dataVizSky,
  },
};

export type ProfileStatusBadgeProps = {
  profileStatus: ProfileStatus;
  name: string;
};

export const ProfileStatusBadge = ({
  profileStatus,
  name,
}: ProfileStatusBadgeProps) => {
  return (
    <Badge
      name={name}
      background={profileStatusColors[profileStatus].colorName}
    >
      {profileStatus}
    </Badge>
  );
};
